module.exports = __webpack_public_path__ + "static/media/ChickenFishSteak.1.41578468.mp4";